import React from 'react'
import { IIconProps as IProps } from './IIconProps'

const IconRefresh = (props: IProps) => (
  <svg
    style={{
      width: `${props.size}px`,
      height: `${props.size}px`,
    }}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 4V1L8 5l4 4V6a6 6 0 0 1 5.917 7.083.999.999 0 1 0 1.969.354A8 8 0 0 0 12 4zm0 14a6 6 0 0 1-5.917-7.083.999.999 0 1 0-1.969-.354A8 8 0 0 0 12 20v3l4-4-4-4v3z"
      fill={props.color}
    />
  </svg>
)

export default IconRefresh
